/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"

const StructuredDataScripts = ({ scripts }) => {
  if (!scripts || !Array.isArray(scripts) || scripts.length === 0) {
    return null
  }

  return (
    <>
      {scripts.map((jsonLd, index) => {
        try {
          const parsedJson = JSON.parse(jsonLd) // Ensure valid JSON
          return (
            <script
              key={index}
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(parsedJson) }}
            />
          )
        } catch (error) {
          console.error("Invalid JSON-LD:", error)
          return null // Skip invalid JSON entries
        }
      })}
    </>
  )
}

function Seo({ description = "", title, children, scriptContent }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <>
      <title>{defaultTitle ? `${title} | ${defaultTitle}` : title}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Techolution" />
      <meta
        property="og:image"
        content="https://cdn.sanity.io/images/nlg69nbd/production/8d5da4e0bbabef7bf9f8ea2a84e91a3a46398449-1113x947.png"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <link
        rel="canonical"
        href={`https://www.techolution.com${useLocation()?.pathname}`}
      />
      <meta name="theme-color" content="#000000" />
      <script type="application/ld+json">
        {JSON?.stringify({
          "@context": "https://schema.org/",
          "@type": "Organization",
          "@id": "#Organization",
          url: "https://www.techolution.com/",
          legalName: "Techolution",
          name: "Techolution",
          description:
            "At Techolution, we build custom AI solutions that produce revolutionary outcomes for enterprises worldwide. Specializing in 'AI Done Right,' we leverage our expertise and proprietary IP to transform operations and help achieve business goals efficiently.",
          image:
            "https://cdn.sanity.io/images/nlg69nbd/production/ad87a8d400625c855125648eaf6b4a403d8c5c64-1456x816.webp",
          logo: "https://cdn.sanity.io/images/nlg69nbd/production/77db5b933536ce1caeecc44303b76d7ba0dd744e-300x82.svg",
          sameAs: [
            "https://www.youtube.com/@techolution8090",
            "https://www.instagram.com/techolution.official?igsh=MXgya2RwM3oxbDdyMQ==",
            "https://www.linkedin.com/company/techolution-mobi",
            "https://x.com/techolution_ai?s=21&t=Sr4DwnKJUKT0TXr38hx6Kw",
          ],
        })}
      </script>
      {scriptContent && <StructuredDataScripts scripts={scriptContent} />}
      {children}
    </>
  )
}

// Seo.defaultProps = {
//   description: ``,
// }

Seo.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default Seo
